import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { Checkbox } from 'vant';
import { Toast, DialogView } from '@hb/coffee';
import { getJumpInfo } from '@/api/increase-credit/increase-credit-zone';
import type { IncreaseCreditListType, contractsType, IncreaseContractType } from '@/api/increase-credit/increase-credit-zone/types';
import { openThirdPage } from '@/api/native/utils';
import { contractsUrl } from '@/constant';


const style = require('./index.module.scss') as Dictionary;

@Component
export default class QuotaIncrease extends Vue {
  /** 认证项内容 */
  @Prop({ default: {} })
  private data!: IncreaseCreditListType;

  /** 认证项协议 */
  @Prop()
  private contractList!: IncreaseContractType;

  @Prop({ default: false })
  private dialogShow!: boolean;

  private checked = false;

  /** 查看协议 */
  private viewProtocols(url:string) {
    const resUrl = /pdf/g.test(url) ? `${contractsUrl}?pdf_url=${url}` : url;
    // TODO: 目前只在app环境中开放入口，不需要处理外跳后页面刷新问题，后续开放其他环境后需要注意处理
    openThirdPage(resUrl);
  }

  /** 点击关闭弹窗按钮 */
  private onClose() {
    this.$emit('close');
    this.checked = false;
  }

  /** 弹窗确认 */
  private async confirm() {
    if (!this.checked) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      Toast('请先同意并勾选协议');
      return;
    }
    this.$ubtPageButton('finance_qualityHomePage_increaseCredit_submitPopUp',
      'dataType',
      this.data.authType);
    const res = await getJumpInfo(this.data.authId);
    this.onClose();
    openThirdPage(res.redirectUrl);
  }


  private render() {
    return (
      <DialogView
        show={this.dialogShow}
        title={ `${this.data.authName}认证跳转` }
        show-confirm-button={false}
        class={style.zoneDialog}
        onCloseIconClick={this.onClose.bind(this)}
      >
          <div class={style.content}>
            您即将前往可信取数平台进行{this.data.authName}公证，请根据提示下载{this.data.authName}
          </div>
          <div class={style.button} onClick={this.confirm.bind(this)}>
            确认
          </div>

            <div class={style.checkContent}>
            <Checkbox v-model={this.checked} checked-color='#ff5729'/>
            <div class={style.text}>
              <span>授权查询{this.data.authName}全程记录操作过程，并对获取的文件进行存管保全，我已阅读并同意</span>
              {
                this.contractList && this.contractList.contracts.map(
                  (item: contractsType) => (
                  <span
                    class={style.colorText}
                    onClick={() => this.viewProtocols(item.contractUrl)}
                  >《{ item.contractName }》</span>
                  ),
                )
              }
            </div>
          </div>
        </DialogView>
    );
  }
}
